import Vue from 'vue'
// 在这里引入你所需的组件
import {
    Button,
    Cell,
    CellGroup,
    Icon,
    Tabbar,
    TabbarItem,
    Field,
    Popup,
    Picker,
    Calendar,
    Form,
    NavBar,
    Uploader,
    Dialog,
    Toast,
    Empty,
    DatetimePicker,
    Loading,
    SubmitBar,
    Checkbox, 
    CheckboxGroup,
    Image as VanImage,
    Search,
    ImagePreview,
    ShareSheet,
    // DatePicker,
    // 。。。
} from 'vant'

// 按需引入UI组件
Vue.use(Button)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Icon)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Field)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(Calendar)
Vue.use(Form)
Vue.use(NavBar)
Vue.use(Uploader)
Vue.use(Dialog)
Vue.use(Toast)
Vue.use(Empty)
Vue.use(DatetimePicker)
Vue.use(Loading)
Vue.use(SubmitBar)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(VanImage)
Vue.use(Search)
Vue.use(ImagePreview)
Vue.use(ShareSheet)
// Vue.use(DatePicker)
	// 。。。
